import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";
import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";
import LoadingSpinner from "../UIComponents/LoadingSpinner";
import SallieSVG from "../../images/sallie.svg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
  getInviterInfoForExistingTP,
  sendConfirmEmail,
  creatConnectionForExistingTP,
} from "../../api/helpReq";

const EmailConfirmForExistingTP = ({ setOnboardingPercent, user }) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const url = new URLSearchParams(location.search);
  const token = url.get("token");
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [userType, setUserType] = useState(null);
  const [patientEmail, setPatientEmail] = useState(null);
  const [caregiverEmail, setCaregiverEmail] = useState(null);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setOnboardingPercent(10);
    if (token) {
      getInviterInfoForExistingTP({ token })
        .then((res) => {
          const { data } = res;
          setFirstName(data.first_name);
          setLastName(data.last_name);
          setUserType(data.user_type);
          setPatientEmail(data.patient_email);
          setCaregiverEmail(data.caregiver_email);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setError(true);
          setLoading(false);
        });
    }
  }, []);

  const reSendEmail = () => {
    const { firstName, lastName, email } = user;
    sendConfirmEmail({ email, name: firstName + " " + lastName });
    history.push("/Verification/EmailSent");
  };

  const clickHandlerLogin = async () => { history.push("/"); };

  const clickHandler = async () => {
    try {
      setSubmitting(true);
      creatConnectionForExistingTP({ token })
        .then(() => { setSubmitting(false); setSuccess(true); })
        .catch((err) => { console.error(err); history.push("/oops"); });
    } catch (err) {
      setSubmitting(false);
      history.push("/oops");
    }
  };

  const sallieMsg = `Hi! A ${userType} named ${firstName} ${lastName} from email ${patientEmail || caregiverEmail} is requesting a connection. By connecting, you will have access to view your patient's reports & send secure messages. Click on the Confirm button now to set the connection!`;

  return (
    <>
      <div className="d-flex justify-content-center">
        <h4 className="mt-4 mb-4">{t("emailconfirm_provider.title")}</h4>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <>
          <Sallie text={t("emailconfirm_provider.error")} variant="sad" />
          <SubmitButton disabled={submitting} onClick={reSendEmail}>
            {t("emailconfirm_provider.resend")}
          </SubmitButton>
        </>
      ) : (
        <>
          <Row>
            <Col md={2} style={{ minWidth: "125px" }} className="d-flex align-items-center justify-content-center">
              <img style={{ maxWidth: "100%", maxHeight: "100%" }} src={SallieSVG} alt="Dog named Sallie" />
            </Col>
            <Col className="p-0" style={{ maxWidth: "80%" }}>
              <div className="sallie" style={{ fontSize: "1.2rem" }}>{sallieMsg}</div>
            </Col>
          </Row>
          {success === false ? (
            <SubmitButton style={{ marginRight: "13%", fontSize: "1.4rem" }} disabled={submitting} onClick={clickHandler}>
              {t("emailconfirm_provider.confirm")}
            </SubmitButton>
          ) : (
            <>
              <h5 className="d-flex justify-content-center">{t("emailconfirm_provider.success")}</h5>
              <SubmitButton style={{ marginRight: "13%", fontSize: "1.4rem" }} disabled={submitting} onClick={clickHandlerLogin}>
                {t("emailconfirm_provider.login")}
              </SubmitButton>
            </>
          )}
        </>
      )}
    </>
  );
};

export default EmailConfirmForExistingTP;